import React from 'react';
import { Button, Input, Message, Space, Tooltip } from '@bedrock/components';
import { useMemoizedFn } from 'ahooks'
import { Copy } from '@bedrock/icons-react';
import copy from 'copy-to-clipboard';



interface Props {
    isCopyPlaceholder?: boolean;
    placeholder?: string;
    children?: React.ReactElement;
}

export const CopeWrapper = (props: Props) => {
    const { children, isCopyPlaceholder = false, ...resProps } = props
    const handleCopy = useMemoizedFn(() => {
        copy(resProps?.placeholder)
        Message.success('复制成功')
    })

    const tooltipTitle = resProps?.placeholder
        ? <span className="whitespace-pre-line">{resProps.placeholder}</span>
        : undefined;

    if (!isCopyPlaceholder) {
        return children
    }
    return (
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
            {children}
            {isCopyPlaceholder && <Tooltip title={tooltipTitle}><Button type="link" icon={<Copy />} onClick={handleCopy}>
                复制填写说明
            </Button></Tooltip>}
        </Space>
    )

}


type CInputProps = Props & React.ComponentProps<typeof Input>
export function CopeInput(props: CInputProps) {
    const { isCopyPlaceholder = false, ...resProps } = props
    return (
        <CopeWrapper
            isCopyPlaceholder={isCopyPlaceholder}
            placeholder={resProps?.placeholder}
        >
            <Input {...resProps} />
        </CopeWrapper>
    )
}


type CInputTextAreaProps = Props & React.ComponentProps<typeof Input.TextArea>
export function CopyTextArea(props: CInputTextAreaProps) {
    const { isCopyPlaceholder = false, ...resProps } = props
    return (
        <CopeWrapper
            isCopyPlaceholder={isCopyPlaceholder}
            placeholder={resProps?.placeholder}
        >
            <Input.TextArea {...resProps} />
        </CopeWrapper>
    )
}

export default CopeWrapper;